import { render, staticRenderFns } from "./ModalRenombrarDocumento.vue?vue&type=template&id=5ac57d68&scoped=true"
import script from "./ModalRenombrarDocumento.vue?vue&type=script&lang=js"
export * from "./ModalRenombrarDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac57d68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ac57d68')) {
      api.createRecord('5ac57d68', component.options)
    } else {
      api.reload('5ac57d68', component.options)
    }
    module.hot.accept("./ModalRenombrarDocumento.vue?vue&type=template&id=5ac57d68&scoped=true", function () {
      api.rerender('5ac57d68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documento/ModalRenombrarDocumento.vue"
export default component.exports